// Lista de segmentos do vendedor (0037, pedido dela 11/10). O cliente guarda o
// NOME (texto), nao uma chave: excluir da lista nao mexe em cliente nenhum.

function chave(nome: string): string {
  return nome.normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase()
}

export function mesmoSegmento(a: string, b: string): boolean {
  return chave(a) === chave(b)
}

// O que o select mostra para um cliente: a opcao da lista que bate com o valor
// gravado (o banco tinha "DISTRIBUIDORA", "Panificação " com espaco); se nada
// bate, o proprio valor -- nunca vazio, senao salvar apagaria o segmento.
export function valorNaLista(valor: string, lista: readonly string[]): string {
  if (!valor.trim()) return ''
  return lista.find((n) => mesmoSegmento(n, valor)) ?? valor
}

export function opcoesDeSegmento(lista: readonly string[], valorAtual: string): string[] {
  const op = [...lista]
  if (valorAtual.trim() && !op.some((n) => mesmoSegmento(n, valorAtual))) op.push(valorAtual)
  return op.sort((a, b) => a.localeCompare(b, 'pt-BR'))
}

export function nomeNovoValido(nome: string, lista: readonly string[]): 'ok' | 'vazio' | 'repetido' {
  if (!nome.trim()) return 'vazio'
  return lista.some((n) => mesmoSegmento(n, nome)) ? 'repetido' : 'ok'
}
